export default "/bitrix/js/landing/ui/panel/formsettingspanel/content/analytics/dist/images/yandex.svg"